import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { VehicleBrand } from './vehicle-brand';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable({ providedIn: 'root' })
export class VehicleBrandService {

    private api_url = `${environment.ApiUrl}/vehicleBrand`;

    constructor(private http: HttpClient) { }

    findAll() {
        return this.http.get<VehicleBrand[]>(this.api_url);
    }

    save(vehicleBrand: VehicleBrand) {
        return this.http.post<VehicleBrand>(this.api_url, vehicleBrand, httpOptions);
    }

    update(vehicleBrand: VehicleBrand) {
        return this.http.put<VehicleBrand>(this.api_url, vehicleBrand, httpOptions);
    }

    delete(vehicleBrand: VehicleBrand) {
        const url = `${this.api_url}/${vehicleBrand.id}`;
        return this.http.delete(url, httpOptions);
    }
}